import React, { useState, useEffect } from 'react';
import axios from "axios";
import * as Constants from './../../store/index';
import SelectHtml from './SelectHtml';

const SEARCH = " (ID:";
function InputSegments(props) {
    const { name, onClick, disabled, value } = props;

    const getSegments = function(callback, callbackError){
        const url = Constants.URL_API+"marketing/campaigns/segments";//https://api.revie.lat/api/marketing/campaigns/segments
        axios.get(url, Constants.getHeaders()).then(response => response.data,error => {
            console.log(error);
            callbackError(error.response);
            return error;
          }).then((data) => {
            callback(data);
        });
      }

      const [sids, setSids] = useState(null);
      const [sidsObjet, setSidsObjet] = useState(null);
      
      const isOK = (data) => {
          console.log(data);
          setSids(data);
          let obj = {};

          data.map((key) =>  {
              obj[key.id] = key.name;
          });
          setSidsObjet(obj);
      }
  
      const isError = (error) => {
  
      }
  
      useEffect(() => {
          if(sids === null){
            getSegments(isOK, isError);
          }
      }, []);
  
    const change = (id) => {
        /*if (text.includes(SEARCH)){
            const myArray = text.split(SEARCH);
            if(myArray[1]){
                if (myArray[1].includes(")")){
                    const myArray2 = myArray[1].split(")");
                    onClick(myArray2[0], name, text);
                }else{
                    onClick("", name);
                }
            }
        }*/
        onClick(id, name, sidsObjet[id] + " (" + id+")");
    }
    const getValue = (item) =>{
        return item.name + SEARCH + item.id + ")";
    }
    return (
        <div>
            {/*<input list={name} className='input-form' disabled={disabled} id="input-segment" onChange={e => change(e.target.value)} />
            <select value={value} onChange={e => change(e.target.value)} className='input-form' disabled={disabled} > 
                {sids && sids.map((item, key) => (
                    <option key={key} value={item.id} selected={item.id === value}>{getValue(item)}</option>
                ))}
            </select>*/}
            <SelectHtml value={value} disabled={disabled} values={sids} defaultText={"Seleccione"} defaultValue={""} onChange={change}/>
        </div>
    );
}
    
export default InputSegments;
